export default "__VITE_ASSET__CgMy9SVQ__"